var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c(
        "mask",
        {
          staticStyle: { "mask-type": "luminance" },
          attrs: {
            id: _vm.maskId,
            maskUnits: "userSpaceOnUse",
            x: "1",
            y: "1",
            width: "18",
            height: "18"
          }
        },
        [
          _c("path", {
            attrs: {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d:
                "M17.4979 9.14508H17.5004C17.9595 9.14508 18.3329 9.51675 18.3337 9.97591C18.3404 12.2017 17.4795 14.2976 15.9095 15.8759C14.3404 17.4542 12.2504 18.3267 10.0245 18.3334H10.0004C7.78286 18.3334 5.69703 17.4734 4.12453 15.9092C2.5462 14.3401 1.6737 12.2501 1.66703 10.0242C1.66036 7.79758 2.5212 5.70258 4.0912 4.12425C5.66036 2.54591 7.75036 1.67341 9.9762 1.66675C10.6387 1.67675 11.3137 1.74341 11.9604 1.89841C12.407 2.00675 12.6829 2.45675 12.5745 2.90425C12.467 3.35091 12.0145 3.62591 11.5695 3.51925C11.052 3.39425 10.5029 3.34175 9.9812 3.33341C8.20036 3.33841 6.52786 4.03675 5.27286 5.29925C4.01703 6.56175 3.3287 8.23841 3.3337 10.0192C3.3387 11.8001 4.03703 13.4717 5.29953 14.7276C6.55786 15.9784 8.2262 16.6667 10.0004 16.6667H10.0195C11.8004 16.6617 13.4729 15.9634 14.7279 14.7009C15.9837 13.4376 16.672 11.7617 16.667 9.98092C16.6662 9.52091 17.0379 9.14591 17.4979 9.14508ZM10.0004 5.83341C9.54036 5.83341 9.16703 6.20675 9.16703 6.66675V10.8334C9.16703 11.2934 9.54036 11.6667 10.0004 11.6667C10.4604 11.6667 10.8337 11.2934 10.8337 10.8334V6.66675C10.8337 6.20675 10.4604 5.83341 10.0004 5.83341ZM10.0004 12.5001C9.54036 12.5001 9.16703 12.8734 9.16703 13.3334C9.16703 13.7934 9.54036 14.1667 10.0004 14.1667C10.4604 14.1667 10.8337 13.7934 10.8337 13.3334C10.8337 12.8734 10.4604 12.5001 10.0004 12.5001Z",
              fill: "white"
            }
          })
        ]
      ),
      _c("g", { attrs: { mask: "url(#" + _vm.maskId + ")" } }, [
        _c("rect", { attrs: { width: "20", height: "20", fill: _vm.color } })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }